import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError, getCookie } from '../../utils'


export const companyDetailTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS', 'REQUEST_UPDATE', 'RECEIVE_UPDATE', 'ERROR_UPDATE'], 'COMPANYDETAILS');


export const requestCompanyDetails = () => {
    return {
        type: companyDetailTypes.REQUEST,
    };
};

export const receiveCompanyDetails = (response) => {
    return {
        type: companyDetailTypes.RECEIVE,
        data: response,
    };
};

export const receiveCompanyDetailsError = (response) => {
    return {
        type: companyDetailTypes.ERROR,
        error: response,
    };
};

// // Set current company, on link click 
// export const setCurrentCompany = (response) => {
//     return {

//     };
// };

export const fetchCompanyDetails = (kennitala) => {
    return dispatch => {

        let success = true

        const apiUrl = `/api/v1/company/`

        dispatch(requestCompanyDetails());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch((kennitala === undefined) ? apiUrl : apiUrl+`${kennitala}/`, {
            headers: headers
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveCompanyDetails(response));
            } else {
                dispatch(receiveCompanyDetailsError(response))
            }
        })
        .catch(handleNetworkError);
    };
};

export const requestCompanyUpdate = () => {
    return {
        type: companyDetailTypes.REQUEST_UPDATE,
    };
};

export const receiveCompanyUpdate = (response, query={}) => {
    return {
        type: companyDetailTypes.RECEIVE_UPDATE,
        query: query,
        data: response,
    };
};

export const receiveCompanyUpdateError = (response) => {
    return {
        type: companyDetailTypes.ERROR_UPDATE,
        error: response,
    };
};


export const updateCompanyDetails = (companyId, data={}) => {
    return dispatch => {

        let success = true

        let apiUrl = `/api/v1/company/${companyId}/update/`

        dispatch(requestCompanyUpdate());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=UTF-8',
            'X-CSRFToken': getCookie("csrftoken"),
        }
        const payload = JSON.stringify(data);
        const body = (typeof TextEncoder !== 'undefined')
            ? new TextEncoder().encode(payload)
            : new Blob([payload], { type: 'application/json; charset=UTF-8' });

        return fetch(apiUrl, {
            headers: headers,
            method: 'POST',
            body: body
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveCompanyUpdate(response, companyId));
            } else {
                dispatch(receiveCompanyUpdateError(response))
            }
        })
        .catch(handleNetworkError);
    };
};